import Big from 'big.js';
import _ from 'lodash';



export function convertCentsToDollars(cents: number) {
  const centsAsString = _.replace(cents.toString(), '.', '');
  const fullCents = centsAsString.length >= 3 ? centsAsString : _.padStart(centsAsString, 3, '0');

  const centsAsDollars = _.join([
    fullCents.substring(0, fullCents.length - 2),
    fullCents.substring(fullCents.length - 2)
  ], '.');

  return centsAsDollars;
}



export function convertBigCentsToDollars(cents: Big) {
  return '$' + cents.div(100).toFixed(2);
}
